import { createRoute, lazyRouteComponent, Outlet, redirect } from '@tanstack/react-router';
import { lazy } from 'react';
import { rootRoute } from '../services/routing/rootRoute';
import { routeLabels } from '../services/routing/routeMetadata';

const systemRoute = createRoute({ getParentRoute: () => rootRoute, path: 'system', component: Outlet });
const systemIndexRoute = createRoute({ getParentRoute: () => systemRoute, path: '/', beforeLoad: () => redirect({ to: '/system/repros', throw: true }) });
const overviewRoute = createRoute({
  getParentRoute: () => systemRoute,
  path: 'repros',
  component: lazyRouteComponent(() => import('@puffin/system-snapshots/overview-page'), 'OverviewPage'),
  staticData: { ...routeLabels('Repro Systems'), navigationPath: '/system/repros' },
});
const createReproRoute = createRoute({
  getParentRoute: () => systemRoute,
  path: 'repros/new',
  component: lazyRouteComponent(() => import('@puffin/system-snapshots/create-repro-page'), 'CreateReproPage'),
  staticData: {
    ...routeLabels('Create Repro'),
    navigationPath: '/system/repros',
    parentBreadcrumbs: [{ useLabel: () => 'Repro Systems', to: '/system/repros' }],
  },
});
const LazyDetails = lazy(async () => {
  const { ReproDetailsPage } = await import('@puffin/system-snapshots/repro-details-page');
  return { default: ReproDetailsPage };
});
const detailsRoute = createRoute({
  getParentRoute: () => systemRoute,
  path: 'repros/$jobId',
  component: () => <LazyDetails jobId={detailsRoute.useParams().jobId} />,
  staticData: {
    ...routeLabels('Repro Details'),
    navigationPath: '/system/repros',
    parentBreadcrumbs: [{ useLabel: () => 'Repro Systems', to: '/system/repros' }],
  },
});

export const systemRouteTree = systemRoute.addChildren([systemIndexRoute, overviewRoute, createReproRoute, detailsRoute]);
